import * as log from 'loglevel';

// We set trace here but strip debug/trace when building for prod
log.setLevel(log.levels.TRACE);
(window as any).log = log.noConflict();
